module.exports = __webpack_public_path__ + "static/media/generator.83075cfc.png";